import React from "react";
import { Header, Footer } from "./index";
import { Container } from "../ui/Container";
import { ScrollToTop } from "../ui/ScrollToTop";
import { SEO } from "../SEO";

interface LegalPageLayoutProps {
  title: string;
  description?: string;
  children: React.ReactNode;
}

const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({
  title,
  description,
  children,
}) => {
  return (
    <>
      <SEO
        title={title}
        description={
          description ||
          `${title} - Setgo Innovations Private Limited. Digistore Pay, SetGo Edutech, Easy Jobs.`
        }
        type="article"
      />
      <div className="min-h-screen bg-white">
        <Header />
        <main className="pt-16 pb-16">
          <Container size="md" padding="md">
            <article className="prose prose-slate max-w-none pt-8">
              {children}
            </article>
          </Container>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
};

export { LegalPageLayout };
